export default __webpack_public_path__ + "assets/simple.27d760bf5a774e108995144383e5f9cd.svg";